import { render, staticRenderFns } from "./StarRadio.vue?vue&type=template&id=f3fc7f6c&scoped=true"
import script from "./StarRadio.vue?vue&type=script&lang=js"
export * from "./StarRadio.vue?vue&type=script&lang=js"
import style0 from "./StarRadio.vue?vue&type=style&index=0&id=f3fc7f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fc7f6c",
  null
  
)

export default component.exports